var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 167,
    viewBox: "0 0 148 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.608 101.334V100.834H146.108H97.3994C98.1301 100.373 99.1116 99.74 100.343 98.937C103.345 97.0607 105.717 95.6251 107.462 94.6283L107.468 94.6246L107.474 94.6208C121.025 86.3396 130.853 78.2859 136.919 70.4519C143.138 62.5816 146.232 52.6963 146.232 40.832C146.232 28.1479 141.146 18.3448 130.983 11.4837C120.975 4.51775 107.398 1.06201 90.3029 1.06201C72.7017 1.06201 59.4074 5.00539 50.5113 12.9801C41.6048 20.9641 37.1924 32.911 37.1924 48.7236V54.9241V55.4241H37.6924H75.6471H76.1471V54.9241V51.9178C76.1471 47.3426 77.0757 43.8952 78.8645 41.5093C80.7315 39.0602 84.109 37.762 89.1756 37.762C92.617 37.762 95.2538 38.5 97.1429 39.9168L97.1568 39.9272L97.1713 39.9366C99.1521 41.2183 100.137 43.0609 100.137 45.5294C100.137 49.9952 98.0896 54.3219 93.8952 58.5164C89.6689 62.7426 82.309 68.5464 71.7907 75.9343C58.865 84.9698 50.0274 93.538 45.339 101.648C40.6596 109.742 38.3818 118.472 38.5076 127.831V138.537V139.037H39.0076H146.108H146.608V138.537V101.334Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8196_8592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 1,
    width: 110,
    height: 138
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.564 101.334H146.108V138.537H39.0076V127.827C38.8824 118.558 41.1371 109.915 45.7719 101.898C50.4066 93.881 59.175 85.3631 72.0771 76.3441C82.5992 68.9536 89.9898 63.1289 94.2487 58.8699C98.5077 54.611 100.637 50.1641 100.637 45.5294C100.637 42.8989 99.5724 40.8947 97.4429 39.5168C95.4387 38.0136 92.6829 37.262 89.1756 37.262C84.0398 37.262 80.4698 38.5773 78.4656 41.2078C76.5866 43.7131 75.6471 47.2831 75.6471 51.9178V54.9241H37.6924V48.7236C37.6924 17.2825 55.2292 1.56201 90.3029 1.56201C107.339 1.56201 120.805 5.00675 130.7 11.8962C140.721 18.6604 145.732 28.3057 145.732 40.832C145.732 52.6068 142.663 62.3773 136.525 70.1436C130.512 77.9099 120.742 85.9268 107.213 94.1942C105.46 95.1963 103.08 96.6368 100.073 98.5157C97.1924 100.395 95.6892 101.334 95.564 101.334Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8196_8592)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8196_8592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0231 0.842051C26.3337 -5.4169 37.9032 -1.43386 44.1621 -1.0545C52.8866 -0.422318 72.0426 1.86625 78.8705 5.96303C87.4053 11.084 90.4399 30.0503 91.7676 40.8611C93.0952 51.6719 84.1811 78.4145 76.0255 82.9664C67.87 87.5183 50.2313 77.8455 42.8344 68.1727C35.4375 58.4998 47.3863 50.7236 47.9553 48.4477C48.5243 46.1717 48.9036 34.0332 44.1621 30.0503C39.4206 26.0674 23.6784 20.7568 17.0402 14.4979C10.402 8.23899 15.7126 7.101 21.0231 0.842051Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.48 36.9387L54.2875 10.0723",
    stroke: "url(#paint0_linear_8196_8592)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.479 82.2759L76.2866 55.4094",
    stroke: "url(#paint1_linear_8196_8592)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 82.8372L36.8076 55.9707",
    stroke: "url(#paint2_linear_8196_8592)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5479 127.544L98.3554 100.677",
    stroke: "url(#paint3_linear_8196_8592)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.649 127.902L146.456 101.036",
    stroke: "url(#paint4_linear_8196_8592)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.943 165.902L146.75 139.036",
    stroke: "url(#paint5_linear_8196_8592)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4214 39.1235L132.229 12.2571",
    stroke: "url(#paint6_linear_8196_8592)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70117 165.8L38.5087 138.933",
    stroke: "url(#paint7_linear_8196_8592)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8196_8592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7749 128.176H110.319V165.379H3.21858V154.669C3.09332 145.4 5.34806 136.757 9.9828 128.74C14.6175 120.723 23.386 112.205 36.2881 103.186C46.8102 95.7957 54.2007 89.9709 58.4597 85.712C62.7186 81.453 64.8481 77.0062 64.8481 72.3714C64.8481 69.7409 63.7833 67.7367 61.6539 66.3588C59.6497 64.8556 56.8939 64.1041 53.3865 64.1041C48.2507 64.1041 44.6807 65.4193 42.6765 68.0499C40.7975 70.5551 39.8581 74.1251 39.8581 78.7599V81.7662H1.90332V75.5656C1.90332 44.1246 19.4402 28.4041 54.5139 28.4041C71.5497 28.4041 85.0154 31.8488 94.9112 38.7383C104.932 45.5025 109.943 55.1477 109.943 67.6741C109.943 79.4488 106.874 89.2193 100.736 96.9857C94.7233 104.752 84.9528 112.769 71.4244 121.036C69.6707 122.038 67.2907 123.479 64.2844 125.358C61.4033 127.237 59.9002 128.176 59.7749 128.176Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.819 128.176V127.676H110.319H61.6103C62.341 127.215 63.3225 126.582 64.5537 125.779C67.5559 123.903 69.928 122.467 71.6725 121.47L71.6788 121.467L71.6851 121.463C85.2362 113.182 95.0639 105.128 101.13 97.2939C107.349 89.4237 110.443 79.5383 110.443 67.6741C110.443 54.9899 105.357 45.1868 95.1938 38.3258C85.1864 31.3598 71.6094 27.9041 54.5139 27.9041C36.9126 27.9041 23.6183 31.8474 14.7222 39.8221C5.81572 47.8062 1.40332 59.753 1.40332 75.5656V81.7662V82.2662H1.90332H39.8581H40.3581V81.7662V78.7599C40.3581 74.1846 41.2866 70.7373 43.0754 68.3513C44.9424 65.9022 48.3199 64.6041 53.3865 64.6041C56.8279 64.6041 59.4648 65.342 61.3539 66.7588L61.3677 66.7692L61.3822 66.7786C63.3631 68.0603 64.3481 69.9029 64.3481 72.3714C64.3481 76.8372 62.3006 81.1639 58.1061 85.3584C53.8799 89.5847 46.5199 95.3885 36.0016 102.776C23.0759 111.812 14.2383 120.38 9.54993 128.49C4.87058 136.584 2.5927 145.314 2.71858 154.673V165.379V165.879H3.21858H110.319H110.819V165.379V128.176Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8196_8592",
    x: -60.6058,
    y: -77.1998,
    width: 227.054,
    height: 235.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.2741,
    result: "effect1_foregroundBlur_8196_8592"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8196_8592",
    x: -4.4651,
    y: 22.0356,
    width: 121.152,
    height: 149.712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8196_8592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8196_8592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8196_8592",
    x1: 19.6752,
    y1: 36.9386,
    x2: 54.2875,
    y2: 10.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8196_8592",
    x1: 41.6742,
    y1: 82.2758,
    x2: 76.2865,
    y2: 55.4094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8196_8592",
    x1: 2.19517,
    y1: 82.8371,
    x2: 36.8075,
    y2: 55.9707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8196_8592",
    x1: 63.743,
    y1: 127.544,
    x2: 98.3554,
    y2: 100.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8196_8592",
    x1: 111.844,
    y1: 127.902,
    x2: 146.456,
    y2: 101.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8196_8592",
    x1: 112.138,
    y1: 165.902,
    x2: 146.75,
    y2: 139.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8196_8592",
    x1: 97.6166,
    y1: 39.1234,
    x2: 132.229,
    y2: 12.2571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8196_8592",
    x1: 3.89634,
    y1: 165.799,
    x2: 38.5087,
    y2: 138.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Full);
export default __webpack_public_path__ + "static/media/2__full.a2f492ae0853415eb19e865bdefe17e4.svg";
export { ForwardRef as ReactComponent };